export const SimpleCheck = ({ height = '24', width = '24' }) => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="24"
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
        <polyline points="20 6 9 17 4 12" transform="translate(7, 2.5)"></polyline>
    </svg>

}


